import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { useWindowDimensions, View } from 'react-native';
import { styles } from './HeaderDesktopV4.styles';
import { MainLogoPressable } from '@photosi/rn-components/main-logo-pressable/MainLogoPressable';
import { PhotoSlotButton } from 'src/editor-v3/components/photo-slot-button/PhotoSlotButton';
import { ProjectSaveButton } from '../../project/project-save-button/ProjectSaveButton';
import { ProjectTitleInput } from '@photosi/rn-components/project/project-title-input/ProjectTitleInput';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { TestIDs } from 'src/constants/testIDs.constants';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { headerEditorTestID } from 'src/helpers/testIDs.helper';

export const HeaderDesktopV4 = observer(() => {
  const {
    project,
    user: { isLogged },
  } = useStore();

  const { isSmallDesktop } = useResponsiveScreen();
  const { width } = useWindowDimensions();

  return (
    <View style={styles.headerContainer}>
      <View style={styles.leftElements}>
        <View style={styles.leftActions}>
          {!project.isProjectAddedToCart && (
            <PhotoSlotButton
              focusId={headerEditorTestID(TestIDs.PHOTO_DRAWER, 'button')}
              focusOrder={0}
              focusGroup={FocusGroups.HEADER}
            />
          )}
        </View>
        {isLogged && !isSmallDesktop && (
          <>
            <View style={styles.separator} />
            <ProjectTitleInput
              maxWidth={width < 1400 ? 380 : undefined}
              focusId={headerEditorTestID(TestIDs.PROJECT_TITLE_INPUT)}
              focusOrder={0}
              focusGroup={FocusGroups.TOOLTIP}
            />
          </>
        )}
      </View>
      <View style={styles.centerElements}>
        <MainLogoPressable
          testID={TestIDs.PHOTOSI_LOGO}
          focusId={TestIDs.PHOTOSI_LOGO}
          focusOrder={10}
          focusGroup={FocusGroups.HEADER}
        />
      </View>
      <View style={styles.rightElements}>
        <ProjectSaveButton isPressTooltipEnabled={isSmallDesktop} focusOrder={11} focusGroup={FocusGroups.HEADER} />
      </View>
    </View>
  );
});
